export function handleKendoBlueImpGallery() {
	$(function () {
		kendo.ui.Window.fn._keydown = function (originalFn) {
			var KEY_ESC = 27;
			return function (e) {

				let imgGallery = $('#blueimp-gallery img').length;

				if (e.which !== KEY_ESC || imgGallery === 0) {
					originalFn.call(this, e);
				}
			};
		}(kendo.ui.Window.fn._keydown);
	});
}